import { IDateData } from '../inputDateReducer';
import getErrorMessage from './getErrorMessage';

export default function setInitialValue(state: IDateData, payload: string) {
	const splitPayload = payload.split('/');
	state.month.value = splitPayload[0];
	state.day.value = splitPayload[1];
	state.year.value = splitPayload[2];

	state.month.valid = true;
	state.day.valid = true;
	state.year.valid = true;

	state.month.visited = !!state.month.value;
	state.month.valueAddAttempted = !!state.month.value;
	state.day.visited = !!state.day.value;
	state.day.valueAddAttempted = !!state.day.value;
	state.year.visited = !!state.year.value;
	state.year.valueAddAttempted = !!state.year.value;

	state.invalidErrorMessage = getErrorMessage(
		state.month.error,
		state.day.error,
		state.year.error,
	);
	return state;
}
